import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { IGetLaudoHigienizacaoPaginated } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.model';
import { UploadService } from 'src/app/services/UploadService/upload.service';
import Swal from 'sweetalert2';

import { ITabelaLaudoHigienizacao } from './listagem-laudos-higienizacao-model';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { formatarData } from 'src/app/core/utils/utilities';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';

type IOptions = {
  name: string;
  value: string | number;
};
@Component({
  selector: 'app-listagem-laudos-higienizacao',
  templateUrl: './listagem-laudos-higienizacao.component.html',
  styleUrls: ['./listagem-laudos-higienizacao.component.scss']
})
export class ListagemLaudosHigienizacaoComponent {
  isLoading: boolean = false;
  form = this._inicializarFormulario();

  numeroPagina: number = 0;
  tableData: ITabelaLaudoHigienizacao[] | Array<any> = [];
  pesquisaParams = {
    TxPesquisar: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 20
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  guid = generateUUID();
  id: number = Number(localStorage.getItem('id'));

  tableColumns = [
    { header: 'Código Laudo', key: 'codigo', type: 'text' },
    { header: 'Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Entrada', key: 'entrada', type: 'text' },
    { header: 'Saída', key: 'saida', type: 'text' },
    { header: 'Placa Cavalo', key: 'placaCavalo', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarLaudoHigienizacao(item)
        },
        {
          label: 'Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) => this.exportPdf(Number(item.codigo))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    private appExportBase64: AppExportBase64
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_PLCA_CRRT: this.fb.control(''),
      DT_GATE_ENTR_INIC: this.fb.control(''),
      DT_GATE_ENTR_FIM: this.fb.control(''),
      FK_MTRT_EXTR: this.fb.control(Number(localStorage.getItem('id')))
    });
    return form;
  }

  editarLaudoHigienizacao(item: any) {
    this.router.navigate(['motorista-externo/cadastro/laudo-higienizacao'], {
      queryParams: {
        codigo: item.codigo,
        modoLaudoHigienizacao: 'Editar'
      }
    });
  }

  visualizarLaudoHigienizacao(item: any) {
    this.router.navigate(['motorista-externo/cadastro/laudo-higienizacao'], {
      queryParams: {
        codigo: item.codigo,
        modoLaudoHigienizacao: 'Visualizar'
      }
    });
  }

  ngOnInit() {
    this.getLaudoHigienizacao();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getLaudoHigienizacao();
    });
  }

  navegarNovoLaudo() {
    this.router.navigate(['motorista-externo/cadastro/laudo-higienizacao']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getLaudoHigienizacao(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  createPayload() {
    const payload: any = {
      ...this.form.value
    };
    Object.keys(payload).forEach(
      key =>
        (payload[key] === null ||
          payload[key] === '' ||
          payload[key] === undefined) &&
        delete payload[key]
    );
    return payload;
  }

  protected getLaudoHigienizacao(pageNumber?: number) {
    this.isLoading = true;
    const idEmpresa = Number(localStorage.getItem('id'));
    const payload = this.createPayload();

    this.laudoHigienizacaoService
      .GetLaudoHigienizacaoPaginated({
        FK_MTRT_EXTR: payload.FK_MTRT_EXTR,
        DT_GATE_ENTR_INIC: payload.DT_GATE_ENTR_INIC,
        DT_GATE_ENTR_FIM: payload.DT_GATE_ENTR_FIM,
        TX_PLCA_CAVA: (payload.TX_PLCA_CRRT ?? '').replace('-', ''),
        pageNumber: pageNumber,
        pageSize: 20
      })
      .subscribe({
        next: (response: IGetLaudoHigienizacaoPaginated) => {
          this.isLoading = false;
          this.tableData = response.ITEMS.map(item => {
            return {
              codigo: item.PK_LAUD_SRVC ?? '---',
              agendamento: formatarData(item.DT_AGND) ?? '---',
              entrada: formatarData(item.DT_GATE_ENTR) ?? '---',
              saida: formatarData(item.DT_GATE_SAID) ?? '---',
              placaCavalo: item.TX_PLCA_CAVA ?? '---',
              motorista: item.NM_MTRT ?? '---',
              situacao: item.DT_GATE_SAID == null ? false : true
            };
          });
          this.maxPages = response.TOTAL_PAGES;
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
  }

  permitirEditar(item: any): boolean {
    return item.situacao;
  }

  exportPdf(id: number) {
    this.isLoading = true;

    this.laudoHigienizacaoService
      .GetReceiptLaudoHigienizacaoById(id)
      .subscribe({
        next: (response: IGetReportBase64) => {
          this.appExportBase64.downloadPDF(
            response.ReportBase64,
            'laudo-higienizacao'
          );
          this.isLoading = false;
        },
        error: _error => {
          this.isLoading = false;
        }
      });
  }
}

